/**
 * People Block JavaScript
 */

(function() {
    'use strict';

    /**
     * Decode obfuscated emails (reverse + base64) into visible mailto links.
     */
    function revealEmails(root) {
        const links = (root || document).querySelectorAll('.people__email[data-e]');

        links.forEach(function(link) {
            const encoded = link.getAttribute('data-e');
            if (!encoded) {
                return;
            }

            try {
                const email = atob(encoded).split('').reverse().join('');
                if (!email || email.indexOf('@') === -1) {
                    return;
                }

                link.href = 'mailto:' + email;
                link.textContent = email;
                link.removeAttribute('data-e');
            } catch (e) {
                // Leave link untouched if decoding fails.
            }
        });
    }

    function initPeople() {
        const blocks = document.querySelectorAll('.people');

        blocks.forEach(function(block) {
            revealEmails(block);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPeople);
    } else {
        initPeople();
    }
})();
